// @file Store for handling mentions.
import device from '@@/bits/device'
import { captureFetchException } from '@@/bits/error_tracker'
import { showMentionSuggestions } from '@@/native_bridge/actions'
import postMessage from '@@/native_bridge/post_message'
import type { MentionEvent } from '@@/vuedirectives/mention_autocomplete'
import { defineStore } from 'pinia'
import PadletApi from 'surface/padlet_api'
import { ref } from 'vue'

export async function fetchAndSendMentionSuggestionsToApp(params: {
  wallId: number
  wishId?: number
  q?: string
}): Promise<void> {
  if (!device.app) return
  try {
    const suggestions = await PadletApi.MentionSuggestions.fetchMentionSuggestions(params)
    postMessage(showMentionSuggestions({ suggestions }))
  } catch (e) {
    captureFetchException(e, { source: 'fetchMentionSuggestions' })
  }
}

export const useMentionsStore = defineStore('mentions', () => {
  /*
   * State
   */

  const xMentionBox = ref(false)
  const mentionPopoverPosition = ref({ top: 0, left: 0 })

  /*
   * Actions
   */

  function showMentionBox(event: MentionEvent): void {
    // There's only one mention box at a time
    hideMentionBox()
    xMentionBox.value = true
    if (event.caretCoordinates != null) {
      mentionPopoverPosition.value = event.caretCoordinates
    }
  }

  function hideMentionBox(): void {
    xMentionBox.value = false
  }

  return {
    // State
    xMentionBox,
    mentionPopoverPosition,

    // Actions
    showMentionBox,
    hideMentionBox,
  }
})
